export default function mergeEncoding(defaultEncoding, encoding) {
  return { ...defaultEncoding,
    ...encoding
  };
}